var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Folder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 27v-4H25.08l-6-6H7v42h50.64l12.18-32H56zm-1.3 28H11l8.69-24H63.4l-8.7 24z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Folder.31b66948.svg";
export { SvgJ2Folder as ReactComponent };